/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import GstDetails from "../../../../../components/_utils/AccountCreationComponents/GstDetails";
import PanDetails from "../../../../../components/_utils/AccountCreationComponents/PanDetails";
import ActiveInactiveAssociatePopup from "../../../../../components/_utils/ActiveInactiveAssociatePopup";
import CommonLayout from "../../../../../components/_utils/CommonLayout";
import LargePopupRedirect from "../../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import GSTVerification from "../../../../Settings/GSTDetails";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import Validation from "../../../../../utils/validation";
import "./index.css";
import CommonAlertCard from "../../../../../components/_utils/CommonAlertCard";
import { verifyGST } from "../../../../../redux/features/sharedResources/sharedResources";
import ICONS from "../../../../../assets/Icons";
import ConfirmBtnAccCreation from "../../../../../components/_utils/AccountCreationComponents/ConfirmBtnAccCreation";

const ReimbursementPanDetails = ({
  verifiedPan,
  panNumber,
  handlePanChange,
  panDetails,
  beneLookData,
  beneLookLoading,
  BenEnableNextButton,
  verifyPANisLoading,
  setIsArchived,
  setIsApproved,
  setIsDennied,
  setIsPending,
  type,
  previousId,
  setIsActive,
  beneLookError,
  hideCreate,
  setPreviousBankNo,
  isLinkedAccount,
  alreadyLinked,
  setPayload,
  payload,
  setShowAccInfo,
  associatedPan,
  setGSTPanExist,
  GSTPanExist,
  accActiveInactiveState,
  setAccActiveInactiveState,
  currentAssociate,
  setCurrentAssociate,
  id,
  isBankLinkedToThisPan,
  shouldNextBtnBeEnabled,
  updateActive,
  setHandleUpdateNext,
  handleUpdateNext,
}) => {
  const dispatch = useDispatch();

  const dropDownOptions = [
    "Beneficiary account",
    "Reimbursement account",
    "Field force account",
  ];

  const [openAssociatePopup, setOpenAssociatePopup] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [customErrors, setCustomErrors] = useState({});
  const [gstVerified, setGstVerified] = useState(null);
  const [GSTStatus, setGSTStatus] = useState(null);
  const associatedAccountRef = useRef(null);
  const [activeTab] = useState("Active");
  const [GSTLinked, setGSTLinked] = useState(true);
  const [verifiedGstValue, setVerifiedGstValue] = useState("");
  const gstRequestValueRef = useRef("");

  const [gstTempData, setGstTempData] = useState(null);
  const { viewAccountDetailData, viewAccountDetailLoading } = useSelector(
    (state) => state.ReimburseAccount,
  );

  const gstNumber =
    viewAccountDetailData?.reimbursement_accounts[0]?.gstin_detail;

  const { gstVerificationData, gstVerificationLoading } = useSelector(
    (state) => state.sharedResources,
  );
  useEffect(() => {
    if (
      payload?.gstin?.length === GlobalConfiguration.gstLength &&
      !customErrors["gstin"]
    ) {
      const gstin = payload?.gstin;
      gstRequestValueRef.current = gstin;
      setVerifiedGstValue("");
      setGSTStatus(Validation.allowedGstin(gstin));

      dispatch(verifyGST({ search_string: gstin })).then((action) => {
        if (gstRequestValueRef.current !== gstin) return;
        if (verifyGST.fulfilled.match(action)) {
          setVerifiedGstValue(gstin);
        }
      });
    } else if (
      payload?.gstin?.length === GlobalConfiguration?.gstLength &&
      customErrors["gstin"]
    ) {
      gstRequestValueRef.current = "";
      setVerifiedGstValue("");
      setGSTStatus(Validation.allowedGstin(payload?.gstin));
    } else {
      gstRequestValueRef.current = "";
      setVerifiedGstValue("");
    }
  }, [payload?.gstin]);

  useEffect(() => {
    if (!gstVerificationLoading) {
      if (gstVerificationData?.status === true) {
        setGstVerified(true);
      } else if (gstVerificationData?.status === false) {
        setGstVerified(false);
      }
    }
  }, [gstVerificationData, gstVerificationLoading]);

  useEffect(() => {
    if (payload?.gstin?.length === GlobalConfiguration.gstLength) {
      let aa = payload.gstin.substring(
        GlobalConfiguration.lengthCheckTwo,
        payload.gstin.length - GlobalConfiguration.accountminLength,
      );
      if (aa === panNumber && gstVerificationData?.status === true) {
        setGSTStatus(true);
        setGstVerified(true);
        setGSTLinked(true);
      } else {
        setGSTStatus(false);
        setGstVerified(false);
        if (aa !== panNumber && gstVerificationData?.status === true) {
          setGSTLinked(false);
        }
        BenEnableNextButton(true);
      }
    } else if (!payload?.gstin && verifiedPan && !verifyPANisLoading) {
      setGSTStatus(null);
    }
  }, [
    gstVerificationData,
    GSTStatus,
    gstVerified,
    payload.gstin,
    verifyPANisLoading,
  ]);

  useEffect(() => {
    if (activeTab === "Active") {
      setIsActive(false);
      setIsApproved(false);
      setIsArchived(false);
      setIsDennied(false);
      setIsPending(false);
    } else if (activeTab === "Inactive") {
      setIsActive(true);
      setIsApproved(false);
      setIsArchived(false);
      setIsDennied(false);
      setIsPending(false);
    }
  }, [activeTab]);

  useEffect(() => {
    let gstStoredData = gstTempData;
    let ActualGstno =
      viewAccountDetailData?.reimbursement_accounts[0]?.gstin_detail;
    let ActualPANno = viewAccountDetailData?.reimbursement_accounts[0]?.pan_no;
    let aa = payload?.gstin?.substring(
      GlobalConfiguration.lengthCheckTwo,
      payload?.gstin?.length - GlobalConfiguration.lengthCheckThree,
    );
    if (viewAccountDetailLoading === false && viewAccountDetailData != null) {
      if (
        viewAccountDetailData?.reimbursement_accounts[0]?.gstin_detail ===
        undefined
      ) {
        if (
          !gstVerificationLoading &&
          gstStoredData != null &&
          payload.gstin !== ""
        ) {
          if (
            payload.gstin?.length === GlobalConfiguration.gstLength &&
            GSTStatus
          ) {
            let aa = payload.gstin.substring(
              GlobalConfiguration.lengthCheckTwo,
              payload.gstin.length - GlobalConfiguration.lengthCheckThree,
            );
            if (aa === panNumber) {
              BenEnableNextButton(false);
              setGSTLinked(true);
            } else {
              BenEnableNextButton(true);
              setGSTLinked(false);
            }
          } else {
            BenEnableNextButton(true);
          }
        } else if (
          verifiedPan &&
          ActualPANno !== panNumber &&
          (GSTStatus == null || !GSTStatus) &&
          payload.gstin?.length === 0
        ) {
          BenEnableNextButton(false);
        } else if (
          verifiedPan &&
          ActualPANno !== panNumber &&
          GSTStatus &&
          payload.gstin?.length === 15
        ) {
          BenEnableNextButton(false);
        } else if (
          verifiedPan &&
          ActualPANno !== panNumber &&
          payload.gstin?.length === 0
        ) {
          BenEnableNextButton(false);
        } else {
          BenEnableNextButton(true);
          setGSTLinked(false);
        }
      } else if (
        viewAccountDetailData?.reimbursement_accounts[0]?.gstin_detail
      ) {
        if (!gstVerificationLoading) {
          if (ActualGstno !== gstStoredData && gstStoredData != null) {
            if (payload.gstin?.length === 15 && GSTStatus) {
              let aa = payload.gstin.substring(2, payload.gstin.length - 3);
              if (aa === panNumber && GSTStatus) {
                BenEnableNextButton(false);
                setGSTLinked(true);
              } else if (aa !== panNumber && GSTStatus) {
                setGSTLinked(false);
                BenEnableNextButton(true);
              } else {
                BenEnableNextButton(true);
              }
            } else if (panNumber !== ActualPANno && verifiedPan) {
              if (!GSTStatus) {
                BenEnableNextButton(true);
              } else {
                let aa = payload.gstin.substring(2, payload.gstin.length - 3);
                if (aa === panNumber && GSTStatus) {
                  BenEnableNextButton(false);
                  setGSTLinked(true);
                } else if (aa !== panNumber && GSTStatus) {
                  setGSTLinked(false);

                  BenEnableNextButton(true);
                } else {
                  BenEnableNextButton(true);
                }
              }
            } else {
              BenEnableNextButton(true);
              setGSTLinked(false);
            }
          } else if (
            GSTStatus == null &&
            !gstVerificationLoading &&
            panNumber !== ActualPANno &&
            verifiedPan
          ) {
            BenEnableNextButton(false);
          } else if (GSTStatus && aa !== panNumber) {
            setGSTLinked(false);
          } else if ((GSTStatus || aa === panNumber) && gstVerified) {
            setGSTLinked(true);
          }
        } else if (ActualGstno === gstStoredData) {
          BenEnableNextButton(true);
          setGSTLinked(true);
        }
      }
    }
  }, [
    gstTempData,
    payload,
    GSTLinked,
    GSTStatus,
    gstVerified,
    gstVerificationLoading,
    viewAccountDetailData,
    viewAccountDetailLoading,
    isLinkedAccount,
    alreadyLinked,
    verifiedPan,
  ]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      event.stopPropagation();
      if (
        associatedAccountRef.current &&
        !associatedAccountRef.current.contains(event.target)
      ) {
        setShowAccInfo(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [associatedAccountRef]);

  const modifyValue = (type, value) => {
    if (type === "name") {
      return value?.replace(/(\w)(\w*)/g, function (g1, g2) {
        return g1.toUpperCase() + g2.toLowerCase();
      });
    } else if (type === "gstin") {
      return value?.toUpperCase();
    }
    return value.trim();
  };

  const allowedValue = (name, value) => {
    if (name === "gstin") return Validation.allowedGstin(value);
    return true;
  };
  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };

    if (name === "gstin")
      errors = Validation.validateGstin(name, value, errors);
    setCustomErrors(errors);
  };

  const isGstInputDisabled =
    type === "editFlow" &&
    (verifiedPan !== true ||
      panNumber?.length !== GlobalConfiguration.panLength);

  const handleChange = (e) => {
    if (isGstInputDisabled) return;

    const { name, value } = e.target;
    const newValue = modifyValue(name, value.replace(/[^a-zA-Z0-9]/g, ""));
    if (allowedValue(name, value)) {
      validateAndRecordError(name, newValue);
      setPayload((prevState) => ({
        ...prevState,
        [name]: newValue,
      }));

      if (value.trim() === "" && value?.length === 1) {
        return;
      }

      if (name === "gstin") {
        const len = newValue.length;
        gstRequestValueRef.current = "";
        setVerifiedGstValue("");

        BenEnableNextButton(true);

        setGSTLinked(false);
        setGstVerified(false);

        if (len === GlobalConfiguration.gstLength) {
          setGstTempData(newValue);
          setGSTStatus(false);
        } else if (
          len > GlobalConfiguration.lengthCheckZero &&
          len < GlobalConfiguration.gstLength
        ) {
          setGSTStatus(false);
        } else {
          setGstTempData(null);
          setGSTStatus(null);
        }
      }
    }
    setHandleUpdateNext(false);
  };

  useEffect(() => {
    if (payload.gstin?.length > 0 && gstVerificationData?.status === true) {
      let errors = { ...customErrors };
      delete errors["gstin"];
      setCustomErrors(errors);
      setGSTStatus(true);
    }

    if (payload.gstin?.length > 0 && gstVerificationData?.errors) {
      let errors = { ...customErrors };
      errors["gstin"] = gstVerificationData.errors;
      setCustomErrors(errors);
      setGSTStatus(false);
    }
  }, [gstVerificationData]);

  const navigate = useNavigate();

  useEffect(() => {
    beneLookData?.beneficiary_accounts?.forEach((val) => {
      if (val?.id === previousId) {
        setPreviousBankNo(val?.bank_acc_no);
      }
    });
  }, [beneLookData?.beneficiary_accounts]);

  useEffect(() => {
    beneLookData?.beneficiary_accounts?.forEach((val) => {
      if (val?.id === previousId) {
        setGSTPanExist(val?.gstin_detail ? true : false);
      }
    });
  }, [beneLookData?.beneficiary_accounts]);

  useEffect(() => {
    if (gstVerificationData?.gstin_details?.business_name) {
      setPayload({
        ...payload,
        gst_org_name: gstVerificationData?.gstin_details?.business_name,
      });
    }
  }, [gstVerificationData]);

  if (GSTPanExist && payload?.gstin?.length === 0) {
    BenEnableNextButton(true);
  }

  const closeGSTDetailsModal = () => {
    setShowPopup(false);
  };

  const [showDetail, setShowDetail] = useState(null);

  useEffect(() => {
    if (
      !beneLookLoading &&
      !verifyPANisLoading &&
      beneLookError === true &&
      verifiedPan &&
      panNumber?.length === GlobalConfiguration.panLength
    ) {
      setShowDetail(true);
    } else {
      setShowDetail(false);
    }
  }, [
    beneLookLoading,
    verifyPANisLoading,
    beneLookError,
    verifiedPan,
    panNumber,
  ]);

  return (
    <>
      <div className="flex justify-between items-start w-width-full h-height-full m-auto lg:gap-gap-xl pb-padding-xl overflow-y-auto overflow-x-hidden">
        {showPopup && (
          <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center z-[99999] Qmd:bg-PopUp-BackDrop !bg-opacity-80">
            <LargePopupRedirect
              headerTitle="GST Details"
              isfullViewrequired={true}
              fullviewhandleFunction={() =>
                navigate("/settings/GST_verification", {
                  state: gstVerificationData?.gstin_details?.gstin_no,
                })
              }
              closeiconhandleFunction={() => setShowPopup(false)}
            >
              <GSTVerification
                gst_number={gstVerificationData?.gstin_details?.gstin_no}
                closeGSTDetailsModal={closeGSTDetailsModal}
                popup={true}
                setShowPopup={setShowPopup}
                showPopup={showPopup}
              />
            </LargePopupRedirect>
          </div>
        )}

        <div className="px-padding-md lg:px-padding-base pt-padding-md Qsmd:pt-padding-base max-w-tab-width-normal w-width-full mx-auto">
          <CommonLayout>
            <div className="flex flex-col">
              {(isLinkedAccount || alreadyLinked) &&
              verifiedPan &&
              !beneLookLoading ? (
                <div className="mb-margin-sm">
                  <CommonAlertCard
                    texts={
                      "The PAN is already linked to the provided bank. To proceed, update the PAN associated with the account."
                    }
                  />
                </div>
              ) : hideCreate ? (
                <div className="new_message_text_block mt-margin-lg Qsmd:mt-margin-base">
                  <img
                    src={ICONS?.ERROR_WITH_WHITE_CIRCLE}
                    alt="info"
                  />
                  <p>
                    Creating a new account adds it to the active accounts for
                    the provided PAN
                  </p>
                </div>
              ) : beneLookData?.status &&
                panNumber?.length === 10 &&
                verifiedPan &&
                !associatedPan &&
                viewAccountDetailData?.reimbursement_accounts[0]?.pan_no !==
                  panNumber ? (
                <></>
              ) : null}

              {gstNumber ? (
                <div className="mb-margin-md mt-margin-base  Qsmd:mt-margin-base">
                  <CommonAlertCard
                    title="Since PAN and GST are linked"
                    texts={[
                      "To edit PAN, the associated GST must also be provided.",
                      "GST can only be replaced with other GSTs that are associated with the provided PAN.",
                    ]}
                  />
                </div>
              ) : null}

              <div className="dividepan_edit_pan h-auto">
                <PanDetails
                  verifiedPan={verifiedPan}
                  verifyPANisLoading={verifyPANisLoading}
                  panNumber={panNumber}
                  handlePanChange={handlePanChange}
                  panDetails={panDetails}
                />
              </div>

              <div
                className="dividepan_edit_pan h-auto rounded-border-radius-md"
                disabled={isGstInputDisabled}
                style={{
                  backgroundColor: isGstInputDisabled ? "var(--Blue-3)" : "",
                  opacity: isGstInputDisabled
                    ? "var(--light-opacity)"
                    : "var(--base-opacity)",
                }}
              >
                <GstDetails
                  GSTStatus={GSTStatus}
                  gstVerified={gstVerified}
                  beneVerifyGST={gstVerificationData}
                  isGSTLoading={gstVerificationLoading}
                  GSTLinked={GSTLinked}
                  GstNumber={payload.gstin}
                  setShowPopup={setShowPopup}
                  handleChange={handleChange}
                  isInputDisabled={isGstInputDisabled}
                />
              </div>
            </div>

            <div
              className={`w-width-full flex flex-col h-auto relative Qlg:p-padding-base p-padding-md ${openAssociatePopup ? "" : "z-z-index-base"}`}
            >
              {verifiedPan === true &&
                beneLookLoading === false &&
                verifyPANisLoading === false &&
                shouldNextBtnBeEnabled &&
                ((!GSTPanExist && !payload?.gstin) ||
                  (verifiedGstValue === payload.gstin &&
                    gstVerificationData?.status === true &&
                    GSTLinked)) && (
                  // !updateActive &&
                  <div style={{ overflow: "hidden" }}>
                    <div
                      className={
                        verifiedPan === false ? "" : "animate-slideInFromRight"
                      }
                    >
                      <ConfirmBtnAccCreation
                        type="pan"
                        status={beneLookData?.status}
                        lookupNext={handleUpdateNext}
                        GSTStatus={GSTStatus}
                        isGSTLoading={gstVerificationLoading}
                        selected={ICONS?.SELECTED_WITH_GREEN_CIRCLE}
                        not_selected={ICONS?.NOT_SELECTED_WITH_GREY_CIRCLE}
                        handleClick={() => {
                          setHandleUpdateNext((confirmed) => !confirmed);
                        }}
                      />
                    </div>
                  </div>
                )}
              <ActiveInactiveAssociatePopup
                dropDownNo={1}
                flow={
                  verifiedPan === false
                    ? "hideAssociate"
                    : (isLinkedAccount || alreadyLinked) && verifiedPan
                      ? "Existing"
                      : showDetail
                        ? "notFoundPan"
                        : !showDetail && verifiedPan
                          ? "Pan"
                          : "defaultPan"
                }
                dropDownOptions={dropDownOptions}
                pan={payload?.panNumber}
                ifsc={isBankLinkedToThisPan?.ifsc_code}
                bank={isBankLinkedToThisPan?.bank_acc_no}
                accActiveInactiveState={accActiveInactiveState}
                setAccActiveInactiveState={setAccActiveInactiveState}
                currentAssociate={currentAssociate}
                setCurrentAssociate={setCurrentAssociate}
                openAssociatePopup={openAssociatePopup}
                setOpenAssociatePopup={setOpenAssociatePopup}
                activeAssociateId={id}
                panLength={panNumber.length}
              />
            </div>
          </CommonLayout>
        </div>
      </div>
    </>
  );
};

export default ReimbursementPanDetails;
